/**
 * Format a USD amount for display, picking sane precision across the huge range
 * of asset prices on the page (BTC in the tens of thousands → BONK at $0.00002).
 */
export function formatUsd(value: number): string {
  if (!Number.isFinite(value) || value <= 0) return "$0";
  if (value >= 1000) return `$${value.toLocaleString("en-US", { maximumFractionDigits: 0 })}`;
  if (value >= 1)
    return `$${value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  if (value >= 0.01) return `$${value.toFixed(4)}`;
  // Sub-cent tokens (e.g. BONK) — keep two significant figures.
  return `$${value.toPrecision(2)}`;
}
